var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"absolute":"","inset":"","app":"","padless":""}},[_c('img',{attrs:{"src":require("@images/logo-mini.svg")}}),_c('a',{attrs:{"href":"https://www.zeborne.com/fr/mentions-legales/","target":"_blank"}},[_vm._v(_vm._s(_vm.$t('terms')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }